import { inject, Injectable } from '@angular/core';
import { Content } from '@ngneat/overview';
import { HotToastService, ObservableMessages, Toast } from '@ngxpert/hot-toast';

export type SnackbarConfigParams = Toast<any>;

export interface SnackBarQueueItem {
  message: Content;
  beingDispatched: boolean;
  config?: Partial<SnackbarConfigParams>;
}

const MAX_SNACKBAR_QUEUE = 1;

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  _snackBar = inject(HotToastService);

  openSnackBar(message: string) {
    this.showSnackbar(message);
  }

  showSnackbar(message: Content, config?: Partial<SnackbarConfigParams>) {
    this._snackBar.show(message, {
      ...config,
    });
  }

  showSnackbarError(message: Content, config?: Partial<SnackbarConfigParams>) {
    this.showSnackbar(message, {
      duration: this.getDuration(config),
      ...config,
      type: 'error',
    });
  }

  showSnackbarSuccess(
    message: Content,
    config?: Partial<SnackbarConfigParams>,
  ) {
    this.showSnackbar(message, {
      duration: this.getDuration(config),
      ...config,
      type: 'success',
    });
  }

  showSnackbarWarning(
    message: Content,
    config?: Partial<SnackbarConfigParams>,
  ) {
    this.showSnackbar(message, {
      duration: this.getDuration(config),
      ...config,
      type: 'warning',
    });
  }

  showSnackbarInfo(message: Content, config?: Partial<SnackbarConfigParams>) {
    this.showSnackbar(message, {
      duration: this.getDuration(config),
      ...config,
      type: 'info',
    });
  }

  observe<T>(messages: ObservableMessages<T, any>) {
    return this._snackBar.observe(messages);
  }

  private getDuration(config?: Partial<SnackbarConfigParams>): number {
    if (config?.duration) return config.duration;
    else return 3000;
  }
}
